import { BdsTypo } from 'blip-ds/dist/blip-ds-react';
import React, { useContext } from 'react';
import DailyEngagedUsersContext from '../../../contexts/DailyEngagedUsersContext';
import { CompiledDailyEngagedUsersLessWidthRow } from '../styles';

const CompiledOverspentInformationsComponent: React.FC = () => {
  const { content, compiledDailyEngagedUserDataState } = useContext(DailyEngagedUsersContext);

  return (
    <>
      {compiledDailyEngagedUserDataState.compiledContainsDataOnSelectedMonth && (
        <CompiledDailyEngagedUsersLessWidthRow>
          <BdsTypo tag="h4">
            {content.compiledDailyEngagedUserInformation.baseValueLabel}
            <BdsTypo variant="fs-24" bold="bold">
              {compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.plan.planValue.toLocaleString(
                content.locale,
                {
                  style: 'currency',
                  currency: compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.plan.currencyCode,
                },
              )}
            </BdsTypo>
          </BdsTypo>
          <BdsTypo tag="h4">
            {content.compiledDailyEngagedUserInformation.totalMonthlyLabel}
            <BdsTypo variant="fs-24" bold="bold">
              {content.formatString(
                content.compiledDailyEngagedUserInformation.totalMonthlyValue,
                compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.plan.dailyEngagedUsersQuantity.toLocaleString(),
              )}
            </BdsTypo>
          </BdsTypo>
          <BdsTypo tag="h4">
            {content.compiledDailyEngagedUserInformation.overspentCostLabel}
            <BdsTypo variant="fs-24" bold="bold">
              {content.formatString(
                content.compiledDailyEngagedUserInformation.overspentCostValue,
                compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.plan.overspentDailyEngagedUserValue.toLocaleString(
                  content.locale,
                  {
                    style: 'currency',
                    currency: compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.plan.currencyCode,
                  },
                ),
              )}
            </BdsTypo>
          </BdsTypo>
        </CompiledDailyEngagedUsersLessWidthRow>
      )}
    </>
  );
};

export default CompiledOverspentInformationsComponent;
